/**
 * Cloud configuration (CLOUD_SYNC_SPEC.md §10)
 *
 * The Firebase web config is PUBLIC by design (it identifies the project;
 * security lives in Auth + the Worker's token verification). The API base
 * can be overridden per-environment with VITE_API_BASE.
 */
export const API_BASE = import.meta.env.VITE_API_BASE ||
    'https://sketchchair-api.greg-552.workers.dev';

export const FIREBASE_CONFIG = {
    apiKey: 'AIzaSyBJfpYp7UIWRfdCDW3T41ODUdhWF85giWo',
    authDomain: 'sketchchair.firebaseapp.com',
    projectId: 'sketchchair',
    storageBucket: 'sketchchair.firebasestorage.app',
    messagingSenderId: '930765727878',
    appId: '1:930765727878:web:29af69414e57cb70ea4907',
    measurementId: 'G-NCX3XRQW8K'
};
